import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import '../../../libs/bulma.min.css';
import './TrunksView.css';
import PbxContext from '../../../context/PbxContext';
import { accessLocalStorage, exportSelectTrunkById, exportDeleteTrunks, sendRegisterTrunkSystem } from '../../../services';
import { hasFeature } from '../../../services/permissions';
import Loading from '../../Loading/LoadingModule';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faStop, faPlay, faEdit, faExchangeAlt, faArrowsAltH, faArrowRight, faPhoneSquareAlt } from '@fortawesome/free-solid-svg-icons';

function EndpointsListById() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsHidden, itemsSelectedToEdit, setItemsSelectedToEdit } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const [loading, setLoading] = useState(true);
  const [phones, setPhones] = useState([]);
  const [trunksSelected, setTrunksSelected] = useState([]);
  const [disable, setDisable] = useState(true);
  const [isPlaying, setIsPlaying] = useState(true);
  const [typeRegistry, setTypeRegistry] = useState('unregister');
  const [filterText, setFilterText] = useState('');
  const [userRole, setUserRole] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const [alert, setAlert] = useState({ show: false, type: '', message: '' });

  const history = useHistory();

  const fetchTrunks = async () => {
    
    const trunkReceived = await exportSelectTrunkById({ elements: itemsSelectedToEdit.toString() });

    if(trunkReceived <= 0) return history.push('/config/tronco/lista');
    if(trunkReceived === undefined) return setLoading(true);

    const parseTrunkAddress = (address) => {
      if (!address) return '';
      const afterScheme = address.split(':')[1];
      if (afterScheme === undefined) return '';
      return address.includes('@') ? (afterScheme.split('@')[1] || '') : afterScheme;
    };

    const elements = trunkReceived.map((element) => {
      const result = {
        serverIP: parseTrunkAddress(element.serverIP),
        localIP: parseTrunkAddress(element.localIP),
        nameuser: element.nameuser === null ? '' : element.nameuser,
        pass: element.pass === null ? '' : element.pass,
        qualifyFrequency: element.qualify_frequency,
        regExpiration: element.expiration,
        hasRegistration: element.has_registration === true,
      };
      result.name = element.name;
      result.trunk = element.trunk;
      result.codec = element.codec;

      return result;
    });

    setPhones(elements);
    setLoading(false);
    return true;
  };

  const validateUserLogged = useCallback(async () => {
    const dataUser = await accessLocalStorage.getUserLocalStorage();
    const { user: { role } } = dataUser;
    if (!dataUser) return history.push('/');
    setUserRole(role);

    const elements = await fetchTrunks();
    return;
  }, []);

  const handleChangeSelectedTrunks = (element) => {
    setTrunksSelected((prevState) => {
      const onlineState = prevState.includes(element) ? [...prevState.filter((e) => e !== element)] : [...prevState, element];
      onlineState.length > 0 ? setDisable(false) : setDisable(true)
      return onlineState;
    });
  };
  
  const filteredPhones = phones.filter((phone) => {
    const searchText = filterText.toLowerCase();
    return (
      (phone.name && phone.name.toLowerCase().includes(searchText)) ||
      phone.localIP.toLowerCase().includes(searchText) ||
      phone.serverIP.toLowerCase().includes(searchText) ||
      (phone.trunk && phone.trunk.toLowerCase().includes(searchText)) ||
      (phone.codec && phone.codec.toLowerCase().includes(searchText)) ||
      (phone.nameuser && phone.nameuser.toLowerCase().includes(searchText)) ||
      (phone.pass && phone.pass.toLowerCase().includes(searchText))
    );
  });

  const handleSendRegisterTrunk = async () => {
    setIsPlaying(isPlaying ? false : true)
    setTypeRegistry((prevState) => {
      const type = prevState === 'unregister' ?  'register' : 'unregister'
      return type;
    });
    const result = await sendRegisterTrunkSystem({ type: typeRegistry, trunk: trunksSelected[0] });
    if (result.status !== 200) toggleIsHidden('#alert-registry-send');
  };

  const handleClickEdit = () => {
    if (trunksSelected.length === 0) return;
    setItemsSelectedToEdit([trunksSelected[0]]);
    history.push('/config/tronco/editar');
  };

  const handleClickDelete = async () => {
    setDeleting(true);
    setAlert({ show: false, type: '', message: '' });

    const result = await exportDeleteTrunks(trunksSelected);

    setDeleting(false);
    toggleIsHidden('#alert-confirm-trunks-delete');

    if (!result.success) {
      setAlert({ show: true, type: 'danger', message: result.error });
      return;
    }

    setAlert({ show: true, type: 'success', message: 'Tronco(s) excluído(s) com sucesso!' });
    setTrunksSelected([]);
    setDisable(true);
    validateUserLogged();
  };

  useEffect(() => {
    validateUserLogged()
  }, [validateUserLogged]);

  return (
    <div className="trunks-view-container">
      {loading ? (
        <Loading />
      ) : (
        <div className="trunks-content">
          <div className="trunks-view-header">
            <div className="trunks-view-title-wrapper">
              <svg className="trunks-view-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
              <div>
                <h1 className="trunks-view-title">Visualizar Tronco</h1>
                <p className="trunks-view-subtitle">Detalhes e gerenciamento de troncos</p>
              </div>
            </div>
            <div className="trunks-view-actions">
              <Link to="/config/tronco/lista" className="btn-action-view btn-back-view">
                <FontAwesomeIcon icon={faArrowsAltH} />
                Voltar à Lista
              </Link>
            </div>
          </div>
          <div className="alerts-section">
            {alert.show && (
              <div className={`alert-message alert-${alert.type}`}>
                <div className="alert-header">
                  <span>{alert.type === 'success' ? 'Sucesso!' : 'Erro!'}</span>
                  <button className="alert-close" onClick={() => setAlert({ show: false, type: '', message: '' })}>×</button>
                </div>
                <div className="alert-body">
                  {alert.message}
                </div>
              </div>
            )}

            <div id="alert-confirm-trunks-delete" className="alert-message alert-danger is-hidden">
              <div className="alert-header">
                <span>Atenção!</span>
                <button className="alert-close" onClick={() => toggleIsHidden('#alert-confirm-trunks-delete')}>×</button>
              </div>
              <div className="alert-body">
                Tem certeza que quer deletar o(s) tronco(s) selecionados?
              </div>
              <div className="alert-actions">
                <button className="btn-alert btn-alert-confirm" disabled={deleting} onClick={() => handleClickDelete()}>
                  <FontAwesomeIcon icon={faTrash} />
                  {deleting ? 'Excluindo...' : 'Confirmar'}
                </button>
                <button className="btn-alert btn-alert-cancel" disabled={deleting} onClick={() => toggleIsHidden('#alert-confirm-trunks-delete')}>
                  Cancelar
                </button>
              </div>
            </div>

            <div id="alert-registry-send" className="alert-message alert-danger is-hidden">
              <div className="alert-header">
                <span>Erro!</span>
                <button className="alert-close" onClick={() => toggleIsHidden('#alert-registry-send')}>×</button>
              </div>
              <div className="alert-body">
                Não foi possível registrar/desregistrar o tronco!
              </div>
            </div>
          </div>

          <div className="filter-section">
            <div className="filter-input-wrapper">
              <svg className="filter-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
              <input
                type="text"
                className="filter-input"
                placeholder="Filtrar por nome, IP, tronco, codec, usuário ou senha..."
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
              />
              {filterText && (
                <button className="filter-clear" onClick={() => setFilterText('')}>
                  ×
                </button>
              )}
            </div>
            <div className="filter-results">
              Exibindo {filteredPhones.length} de {phones.length} tronco(s)
            </div>
          </div>

          <div className="trunks-table-wrapper">
            <table className="trunks-table">
              <thead className="trunks-table-header">
                <tr>
                  <th>Sel.</th>
                  <th>Nome</th>
                  <th>IP Local</th>
                  <th>IP Remoto</th>
                  <th>Tronco</th>
                  <th>Codec</th>
                  <th>Usuário</th>
                  <th>Senha</th>
                  <th>Monitoramento (seg)</th>
                  <th>Registro (seg)</th>
                  <th className="th-actions">Ações</th>
                </tr>
              </thead>
              <tbody>
                {filteredPhones.map((phone) => {
                  const {
                    name, localIP, serverIP, trunk, codec, nameuser, pass,
                    qualifyFrequency, regExpiration, hasRegistration,
                  } = phone;
                  const qualifyDisplay = qualifyFrequency === 0
                    ? 'Desativado'
                    : `${qualifyFrequency ?? 120}${qualifyFrequency == null ? ' (padrão)' : ''}`;
                  const expirationDisplay = hasRegistration
                    ? `${regExpiration ?? 3600}${regExpiration == null ? ' (padrão)' : ''}`
                    : 'Sem registro';
                  return (
                    <tr key={name}>
                      <td>
                        <input 
                          name="selectTrunk" 
                          id={name} 
                          type="radio" 
                          value={name} 
                          onClick={(e) => handleChangeSelectedTrunks(e.target.value)}
                        />
                      </td>
                      <td className="td-name">{name}</td>
                      <td>{localIP}</td>
                      <td>{serverIP}</td>
                      <td>{trunk}</td>
                      <td style={{ textTransform: 'uppercase' }}>{codec}</td>
                      <td>{!nameuser ? 'N/A' : nameuser}</td>
                      <td>{!pass ? 'N/A' : pass}</td>
                      <td>{qualifyDisplay}</td>
                      <td>{expirationDisplay}</td>
                      <td className="td-actions">
                        <div className="trunk-actions-cell">
                          {hasFeature('config.troncos', 'edit') && (
                            <button
                              className="btn-trunk-action btn-edit-trunk"
                              onClick={handleClickEdit}
                              disabled={disable}
                              title="Editar tronco"
                            >
                              <FontAwesomeIcon icon={faEdit} />
                            </button>
                          )}
                          {hasFeature('config.troncos', 'delete') && (
                            <button
                              className="btn-trunk-action btn-unregister"
                              onClick={() => toggleIsHidden('#alert-confirm-trunks-delete')}
                              disabled={disable}
                            >
                              <FontAwesomeIcon icon={faTrash} />
                            </button>
                          )}
                          {hasFeature('config.troncos', 'edit') && (
                          <button
                            className="btn-trunk-action btn-register"
                            onClick={() => handleSendRegisterTrunk()}
                            disabled={disable}
                          >
                            {isPlaying ? (
                              <FontAwesomeIcon icon={faStop} />
                            ) : (
                              <FontAwesomeIcon icon={faPlay} />
                            )}
                          </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

export default EndpointsListById;
